import indexMixin from "../mixins/index";
export default {
  name: 'res-textarea',
  mixins: [indexMixin],
  props: {
    value: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      dataModel: this.value
    };
  },

  watch: {
    value: {
      handler(val) {
        this.dataModel = val;
      },

      deep: true
    },

    dataModel(val) {
      this.$emit("input", val);
    }

  },
  methods: {}
};